/**
 * @generated SignedSource<<04e5e3dc155ab4b06d908fc0f367e924>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type indicatorGalleryIndicatorGallery$data = {
  readonly images: ReadonlyArray<{
    readonly __typename: "Image";
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "indicatorGalleryIndicatorGallery";
};
export type indicatorGalleryIndicatorGallery$key = {
  readonly " $data"?: indicatorGalleryIndicatorGallery$data;
  readonly " $fragmentSpreads": FragmentRefs<"indicatorGalleryIndicatorGallery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "indicatorGalleryIndicatorGallery",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Gallery",
  "abstractKey": null
};

(node as any).hash = "6f7fd19488bb4a29db4c5d942b57f335";

export default node;
